import React, { Fragment } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";

import AuthorisedIcon from "@/Components/Icons/timesheetType/AuthorisedIcon";
import SubmittedIcon from "@/Components/Icons/timesheetType/SubmittedIcon";
import TerminatedIcon from "@/Components/Icons/timesheetType/TerminatedIcon";
import { toggleOurServiceModal } from "@/reducers/clientcommon";

import NotAllowedButtonWrapper from "../managedService/NotAllowedButtonWrapper";

// import { showManagedServiceToast } from "@/utilities/utils";

import NoAccessButtonWrapper from "../UserRoleAccess/NoAccessButtonWrapper";

const TimesheetTypes = () => {
  const { activeSubPage } = useSelector((state) => state.clientCommon);
  const { isPremiumAccount, clientUserAllPermissions } = useSelector(
    (state) => state.session,
  );
  const { typeCount } = useSelector((state) => state.clientTimesheets);
  const { sideBarCollapsed } = useSelector((state) => state.clientCommon);

  // console.log("client_user_all_permission---------", clientUserAllPermissions);

  const dispatch = useDispatch();
  const IconObj = {
    assigned: {
      icon: <SubmittedIcon cls={"h-[22px] w-[22px] lg:h-[25px] lg:w-[25px]"} />,
      color: "text-yellow",
      bg: "bg-yellow-200",
      active: "bg-yellow",
      hoverBg: "hover:bg-yellow",
    },
    submitted: {
      icon: <SubmittedIcon cls={"h-[22px] w-[22px] lg:h-[25px] lg:w-[25px]"} />,
      color: "text-cyan",
      bg: "bg-cyan-200",
      active: "bg-cyan",
      hoverBg: "hover:bg-cyan",
    },
    authorised: {
      icon: (
        <AuthorisedIcon cls={"h-[22px] w-[22px] lg:h-[25px] lg:w-[25px]"} />
      ),
      color: "text-green",
      bg: "bg-green-200",
      active: "bg-green",
      hoverBg: "hover:bg-green",
    },
    terminated: {
      icon: (
        <TerminatedIcon cls={"h-[22px] w-[22px] lg:h-[25px] lg:w-[25px]"} />
      ),
      color: "text-red",
      bg: "bg-red-200",
      active: "bg-red",
      hoverBg: "hover:bg-red",
    },
  };

  // const handleResetAllSearch = () => {
  //   dispatch(updateSubmittedFilters({ reset: true }));
  //   dispatch(updateAuthorisedilters({ reset: true }));
  //   dispatch(updateTerminatedFilters({ reset: true }));
  // };
  // const firstRender = useRef(true);
  // useEffect(() => {
  //   if (firstRender.current) {
  //     firstRender.current = false;
  //     return;
  //   }
  //   handleResetAllSearch();
  // }, [activeSubPage]);
  const GetLink = (ele) => {
    let isPremiumAccountPage = ele.name == "disputed";
    // let hasAccess = clientUserAllPermissions[ele.access];
    let mainObj = IconObj[ele.type];
    return (
      <Link
        to={isPremiumAccountPage && !isPremiumAccount ? "#" : ele.link}
        className={`inline-block w-full ${isPremiumAccountPage && !isPremiumAccount ? "" : "group/tab"} ${
          activeSubPage === ele.name
            ? mainObj.active
            : `bg-white ${isPremiumAccountPage && !isPremiumAccount ? "" : mainObj.hoverBg}`
        } rounded-[14px] p-3 !decoration-none   hover:decoration-none lg:px-4 lg:py-3 xl:px-5 xl:py-4 ${isPremiumAccountPage && !isPremiumAccount ? "opacity-50" : ""} `}
        // key={index}
        onClick={(e) => {
          if (isPremiumAccountPage) {
            if (!isPremiumAccount) {
              e.preventDefault();
              dispatch(toggleOurServiceModal(true));
              // showManagedServiceToast();
            }
          }
        }}
      >
        <div className="flex items-center justify-between gap-3">
          <div
            className={`h-[20px] w-[20px]   lg:h-[25px] lg:w-[25px] ${activeSubPage === ele.name ? "text-white" : `${mainObj.color} group-hover/tab:!text-white`}`}
          >
            {mainObj.icon}
          </div>
          <p
            className={`select-none capitalize   ${
              activeSubPage === ele.name
                ? "text-white"
                : "!text-txtColor group-hover/tab:!text-white"
            } grow text-[14px] font-semibold leading-none 2xl:text-[18px]`}
          >
            {ele.name}
          </p>
          <div
            className={`flex h-[36px] min-w-[44px] items-center justify-center rounded-lg px-1   lg:h-[40px] lg:min-w-[50px] 2xl:h-[44px] 2xl:min-w-[55px] ${
              activeSubPage === ele.name
                ? "bg-white"
                : `${mainObj.bg} ${mainObj.color} group-hover/tab:!bg-white`
            }`}
          >
            <p
              className={`${mainObj.color} select-none text-[min(2vh,18px)] font-bold lg:text-[18px] 2xl:text-[20px]`}
            >
              {ele.value}
            </p>
          </div>
        </div>
      </Link>
    );
  };
  return (
    <div className="TimesheetTypes_Wrapper">
      <div
        className={`grid grid-cols-1 gap-5 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-3 ${sideBarCollapsed ? "xl:grid-cols-5" : "xl:grid-cols-4"} tour-timesheet-types`}
      >
        {typeCount.map((ele, index) => {
          let isPremiumAccountPage = ele.name == "terminated";
          const hasAccess = clientUserAllPermissions[ele.access];

          if (isPremiumAccountPage && !isPremiumAccount) {
            return (
              <Fragment key={index}>
                <NotAllowedButtonWrapper
                  rootClass="rounded-[14px]"
                  iconClass="w-[32px] h-[32px] text-primary"
                >
                  {GetLink(ele)}
                </NotAllowedButtonWrapper>
              </Fragment>
            );
          }
          return (
            <Fragment key={index}>
              {hasAccess === 0 || hasAccess === "undefined" ? (
                <NoAccessButtonWrapper
                  key={ele.name}
                  rootClass="rounded-[14px]"
                  iconClass="w-[32px] h-[32px] text-primary"
                  _checkPermission={[ele.access]}
                >
                  {GetLink(ele)}
                </NoAccessButtonWrapper>
              ) : (
                GetLink(ele)
              )}
            </Fragment>
          );
        })}
      </div>
    </div>
  );
};

export default TimesheetTypes;
